module.exports = __webpack_public_path__ + "public/hws/images/success-big.png";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/success-big.png
// module id = 67
// module chunks = 0